import React from 'react';
import { openCustomersModal } from "../../Redux/SuperAdminModal/modalSlice";
import { useDispatch } from 'react-redux';
import { PiUserSwitchFill } from 'react-icons/pi';
import { Button } from 'antd';


const CustomerContent: React.FC = () => {
    const dispatch = useDispatch();
    const handleOpenCustomersModal = () => {
        dispatch(openCustomersModal());
    };

    return (
        <div className="d-flex align-items-center justify-content-center" style={{ height: '80vh' }}>
            <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: '300px' }}>
                <PiUserSwitchFill size={256} style={{ color: '#D3D3D3' }}/>
                <p className="font-18">Please choose a customer to view licenses</p>
                <Button type="primary" className="mt-3" onClick={handleOpenCustomersModal}>Choose Customer</Button>
            </div>
        </div>
    )
}

export default CustomerContent;